var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-base',{attrs:{"id":_vm.id,"load-url":("/api/forms/admin/" + _vm.id + "/fetch"),"record-key":"form","breadcrumb-items":_vm.breadcrumbs},on:{"loaded":_vm.addBreadcrumb}})}
var staticRenderFns = []

export { render, staticRenderFns }